export const FEATURE_FLAGS = {
  CONSOLIDATED_COMMENTS_SHORTCUT: "CONSOLIDATED_COMMENTS_SHORTCUT",
  NEW_UI_ENABLED: "NEW_UI_ENABLED",
  ENABLE_PROCESS_OVERVIEW: "ENABLE_PROCESS_OVERVIEW",
  ENABLE_WORKFLOW_LINK_DELINK_FEATURE: "ENABLE_WORKFLOW_LINK_DELINK_FEATURE"
};
